import { render, staticRenderFns } from "./NewOrderModal.vue?vue&type=template&id=71994f82&scoped=true"
import script from "./NewOrderModal.vue?vue&type=script&lang=ts"
export * from "./NewOrderModal.vue?vue&type=script&lang=ts"
import style0 from "./NewOrderModal.vue?vue&type=style&index=0&id=71994f82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71994f82",
  null
  
)

export default component.exports